import { defineMessages } from "react-intl";
const messages = defineMessages({
    importAccessDevicesButton: {
        id: "app.sgt.accessDevices.syncAccessDevicesButton",
        defaultMessage: "Import Access Devices",
    },
    importAccessDevicesError: {
        id: "app.sgt.accessDevices.syncAccessDevicesError",
        defaultMessage: "Something went wrong. Please try again later.",
    },
    importAccessDevicesRetry: {
        id: "app.sgt.accessDevices.syncAccessDevicesRetry",
        defaultMessage: "Retry",
    },
});
export default messages;
